export function getUserStories() {
  return [
    {
      title: "Board member or CEO",
      text:
        "I need to make sure risk are well understood and managed, but not necessarily know all the details how.\n" +
        "Building a risk management policy and having the right tools (software) to measure the risk is very important.\n" +
        "Making sure no risky transactions are done is key.\n" +
        "Follow up on the policy’s implementation.\n" +
        "He will be able to visualize past results to make sure costs are acceptable and maybe find ways to improve."
    },
    {
      title: "CFO, treasurer, FX | Comdty analyst",
      text:
        "They are scared of the FX market, showing lack of knowledge – we focus on educating the client\n" +
        "and our quantitative and powerful analysis may be sophisticated, but the client easily understands\n" +
        "the results and how to act according to the conclusions of the analysis.\n" +
        "They like the idea of developing a policy that will be approved by the board and the company direction.\n" +
        "If no such plan exists, they are responsible for anything good or bad that happens.\n" +
        "It’s a big risk for them if thinks don’t work good.\n" +
        "They are more protected and calmed if we are there to help them with the tough hedging decision,\n" +
        "because they only need to follow the plan."
    }
  ];
}
export function getSDD() {
  return [
    {
      idx: 0,
      title: "OVERVIEW",
      due: "2022-03-31",
      relevance: 50,
      ave: 0,
      items: [
        {
          title:
            "Websocket injects market data (missing cont.month > 1, not showing some commodities)",
          value: 80
        },
        { title: "Table and charts layout", value: 100 },
        {
          title: "Forward and volatility curve (missing select currency)",
          value: 90
        }
      ]
    },
    {
      idx: 1,
      title: "DATA MODEL: CURRENCY AND COMMODITY",
      due: "2022-02-23",
      relevance: 40,
      ave: 0,
      items: [
        {
          title: "Exposures: filters (missing download filtered data)",
          value: 90
        },
        {
          title: "Hedges: filters (missing download filtered data)",
          value: 90
        },
        {
          title: "Program: CRUD programs",
          value: 100
        },
        {
          title: "Upload massive files (now up to 1.000 rows)",
          value: 60
        }
      ]
    },
    {
      idx: 2,
      title: "ANALYTICS: CURRENCY",
      due: "2022-03-15",
      relevance: 100,
      ave: 0,
      items: [
        {
          title: "Mark to market (now) (pending Offset)",
          value: 95
        },
        {
          title: "Historical results (past) (pending Offset)",
          value: 95
        },
        {
          title: "Scenario Analysis (future) (pending Offset)",
          value: 95
        },
        {
          title: "Consolidated (testing needed)",
          value: 75
        },
        {
          title: "Derivatives valuation (testing needed)",
          value: 75
        }
      ]
    },
    {
      idx: 3,
      title: "ANALYTICS: COMMODITY",
      due: "2022-04-15",
      relevance: 100,
      ave: 0,
      items: [
        {
          title: "Mark to market (now) (pending Offset)",
          value: 95
        },
        {
          title: "Historical results (past) (pending Offset)",
          value: 95
        },
        {
          title: "Scenario Analysis (future) (pending Offset)",
          value: 95
        },
        {
          title: "Consolidated (testing needed)",
          value: 75
        },
        {
          title: "Derivatives valuation (testing needed)",
          value: 75
        }
      ]
    },
    {
      idx: 5,
      title: "MARKETS: CURRENCY",
      due: "2022-06-30",
      relevance: 40,
      ave: 0,
      items: [
        {
          title: "Currencies",
          value: 100
        },
        {
          title: "Commodities",
          value: 100
        },
        {
          title: "Macro Indicators (include other sources)",
          value: 50
        },
        {
          title: "Correlations",
          value: 100
        },
        {
          title: "Comparison (show conversions)",
          value: 90
        },
        {
          title: "Projections (more sources, other FX)",
          value: 50
        },
        {
          title: "Seasonality (different types)",
          value: 50
        },
        {
          title: "Percentiles",
          value: 100
        },
        {
          title: "Trends (AI)",
          value: 80
        },
        {
          title: "Relative Value",
          value: 100
        },
        {
          title: "Technical Analysis (draw lines)",
          value: 90
        },
        {
          title: "Pattern Recognition (Neural Nets)",
          value: 50
        },
        {
          title: "Pricing (include EA devaluation)",
          value: 90
        }
      ]
    },
    {
      idx: 6,
      title: "MARKETS: COMMODITY",
      due: "2022-06-30",
      relevance: 40,
      ave: 0,
      items: [
        {
          title: "Colombia (testing, include compensations)",
          value: 100
        },
        {
          title: "Currencies",
          value: 100
        },
        {
          title: "Commodities",
          value: 100
        },
        {
          title:
            "Macro Indicators (include other sources, term de interc, gov spending)",
          value: 50
        },
        {
          title: "Correlations",
          value: 100
        },
        {
          title: "Comparison (show conversions)",
          value: 90
        },
        {
          title: "Projections (more sources, other FX)",
          value: 50
        },
        {
          title: "Seasonality (different types)",
          value: 50
        },
        {
          title: "Percentiles",
          value: 100
        },
        {
          title: "Trends (AI)",
          value: 80
        },
        {
          title: "Relative Value",
          value: 100
        },
        {
          title: "Technical Analysis (draw lines)",
          value: 90
        },
        {
          title: "Pattern Recognition (Neural Nets)",
          value: 50
        },
        {
          title: "Pricing: change table",
          value: 0
        }
      ]
    },
    {
      idx: 7,
      title: "OPTIMIZER: CURRENCY",
      due: "2022-06-30",
      relevance: 40,
      ave: 0,
      items: [
        {
          title: "Define notional/dates",
          value: 100
        },
        {
          title: "Quote - calculator",
          value: 100
        },
        {
          title: "Simulations (include view)",
          value: 80
        }
      ]
    },
    {
      idx: 8,
      title: "OPTIMIZER: COMMODITY",
      due: "2022-06-30",
      relevance: 90,
      ave: 0,
      items: [
        {
          title: "Define notional/dates",
          value: 100
        },
        {
          title: "Quote - calculator",
          value: 100
        },
        {
          title: "Simulations (include view)",
          value: 0
        }
      ]
    },
    {
      idx: 9,
      title: "HEDGE: CURRENCY",
      due: "2022-03-31",
      relevance: 100,
      ave: 0,
      items: [
        {
          title: "Hedge",
          value: 60
        },
        {
          title: "Send/receive messages",
          value: 80
        },
        {
          title: "Trader",
          value: 10
        },
        {
          title: "Supervisor",
          value: 0
        }
      ]
    },
    {
      idx: 10,
      title: "NEW: OVERVIEW",
      due: "2022-03-31",
      relevance: 75,
      ave: 0,
      items: [
        {
          title: "New: include IR",
          value: 0
        }
      ]
    },
    {
      idx: 12,
      title: "NEW ANALYTICS: CURRENCY",
      due: "2022-03-15",
      relevance: 85,
      ave: 0,
      items: [
        {
          title: "New: Executive summary",
          value: 0
        },
        {
          title: "New: Portfolio Details",
          value: 0
        },
        {
          title: "New: Rollover-unwind management, trace",
          value: 0
        },
        {
          title: "New: Advanced filters",
          value: 0
        },
        {
          title: "New: Balance ref. rates",
          value: 0
        },
        {
          title: "New: Balance and Cash Flow projection",
          value: 0
        },
        {
          title: "New: Balance risk analysis",
          value: 0
        },
        {
          title: "New: Back-testing creator",
          value: 0
        }
      ]
    },
    {
      idx: 13,
      title: "NEW ANALYTICS: COMMODITY",
      due: "2022-04-15",
      relevance: 90,
      ave: 0,
      items: [
        {
          title: "New: Executive summary",
          value: 0
        },
        {
          title: "New: Portfolio Details",
          value: 0
        },
        {
          title: "New: Rollover-unwind management, trace",
          value: 0
        },
        {
          title: "New: Include Basis + Freight + etc",
          value: 0
        },
        {
          title: "New: Cash Flow projection",
          value: 0
        },
        {
          title: "New: Back-testing creator",
          value: 0
        }
      ]
    },
    {
      idx: 14,
      title: "NEW ANALYTICS: INTEREST RATE",
      due: "2022-04-15",
      relevance: 60,
      ave: 0,
      items: [
        {
          title: "New: mark to market",
          value: 0
        }
      ]
    },
    {
      idx: 15,
      title: "NEW MARKETS: CURRENCY",
      due: "2022-06-30",
      relevance: 40,
      ave: 0,
      items: [
        {
          title: "New: GPT-3: search for mos relevant news",
          value: 0
        },
        {
          title: "New: Interest Rates Comparison",
          value: 0
        },
        {
          title: "New: commitment of traders",
          value: 0
        },
        {
          title: "New: XXX",
          value: 0
        },
        {
          title: "New: XXX",
          value: 0
        },
        {
          title: "New: XXX",
          value: 0
        },
        {
          title: "New: XXX",
          value: 0
        },
        {
          title: "New: FED dot plots, fed funds, 20y10y spread",
          value: 0
        },
        {
          title: "New: Add Latam Index, Commodity FX, CRB",
          value: 0
        }
      ]
    },
    {
      idx: 16,
      title: "NEW MARKETS: COMMODITY",
      due: "2022-06-30",
      relevance: 40,
      ave: 0,
      items: [
        {
          title: "New: futures curve management",
          value: 0
        },
        {
          title: "New: commitment of traders",
          value: 0
        },
        {
          title:
            "New: FED balance sheet, rates, dot plots, fed funds, 20y10y spread",
          value: 0
        },
        {
          title: "New: Add Latam Index, Commodity FX, CRB",
          value: 0
        },
        {
          title: "New: WASDE/OPEC data",
          value: 0
        }
      ]
    },
    {
      idx: 17,
      title: "NEW HEDGE: COMMODITY",
      due: "2022-10-31",
      relevance: 100,
      ave: 0,
      items: [
        {
          title: "Hedge",
          value: 0
        },
        {
          title: "Send/receive messages",
          value: 0
        },
        {
          title: "Trader",
          value: 0
        },
        {
          title: "Supervisor",
          value: 0
        }
      ]
    },
    {
      idx: 17,
      title: "NEW: MINI MUREX",
      due: "2022-12-31",
      relevance: 20,
      ave: 0,
      items: [
        {
          title: "Greeks",
          value: 0
        },
        {
          title: "Interest Rates",
          value: 0
        },
        {
          title:
            "New: FED balance sheet, rates, dot plots, fed funds, 20y10y spread",
          value: 0
        },
        {
          title: "New: Add Latam Index, Commodity FX, CRB",
          value: 0
        },
        {
          title: "New: WASDE/OPEC data",
          value: 0
        }
      ]
    }
  ];
}
export function getPRDs() {
  return [
    {
      title: "Purpose",
      text:
        "We offer our clients all the tools they need to make better hedging decisions.\n" +
        "Our clients will have access to their risk management program, their exposures and their hedges in one place.\n" +
        "Pre-trade: know his hedging needs, how his hedging portfolios are currently performing.\n" +
        "Understand the color (risks of the market), and so on.\n" +
        "Trade: quote real time different strategies and have a benchmark for quoting.\n" +
        "Post-trade: valuation for accounting, follow up, risk measurement, and so on."
    },
    {
      title: "Value",
      text:
        "There isn't many competitors that have this type of solution.\n" +
        "Clients that want to build the tool in house or hiring a company will realize that:\n" +
        "Either the companies that understand derivatives and risk management models (Reuters, Bloomberg), don't build custom made software.\n" +
        "Or the companies that build software (oracle, etc) don't know about valuation, risk management, etc."
    },
    {
      title: "Functionality",
      text:
        "We have apps that allow clients to perform different analysis:\n" +
        "Overview: dashboard with market prices.\n" +
        "Data Model: Upload/Download the company's data (exposures, hedges and program).\n" +
        "Analytics: analyze the portfolio. Valuate, Backtest, Simulate.\n" +
        "Markets: analyze the asset, compare assets, use fundamental information, technical analysis, econometric and machine learning models."
    }
  ];
}

export function getDocumentationItems(_this) {
  return [
    {
      label: "Overview",
      icon: "pi pi-fw pi-compass",
      items: [
        [
          {
            label: "Structure",
            items: [
              {
                label: "Go to Structure",
                command: () => {
                  _this.handleClick("docs");
                }
              }
            ]
          }
        ]
      ]
    },
    {
      label: "Product: System",
      icon: "pi pi-fw pi-check",
      items: [
        [
          {
            label: "Product requirements documents (PRDs)",
            items: [
              {
                label: "Go to PRDs",
                command: () => {
                  _this.handleClick("prds");
                }
              }
            ]
          },
          {
            label: "Software design documents (SDDs)",
            items: [
              {
                label: "Go to SDDs",
                command: () => {
                  _this.handleClick("sdds");
                }
              }
            ]
          },
          {
            label: "User Stories",
            items: [
              {
                label: "Go to User Stories",
                command: () => {
                  _this.handleClick("userStories");
                }
              }
            ]
          }
        ],
        [
          {
            label: "Maintenance guides",
            items: [
              {
                label: "Go to Maintenance",
                command: () => {
                  _this.handleClick("maintenance");
                }
              }
            ]
          },
          {
            label: "API documentation",
            items: [
              {
                label: "Go to API Docs",
                command: () => {
                  _this.handleClick("APIDocs");
                }
              }
            ]
          }
        ]
      ]
    },
    {
      label: "Product: User",
      icon: "pi pi-fw pi-users",
      items: [
        [
          {
            label: "End User Documentation",
            items: [
              {
                label: "Go to End User Docs",
                command: () => {
                  _this.handleClick("endUserDocs");
                }
              }
            ]
          },
          {
            label: "Sysadmin Documentation",
            items: [
              {
                label: "Go to Sysadmin",
                command: () => {
                  _this.handleClick("sysadmin");
                }
              }
            ]
          }
        ]
      ]
    },
    {
      label: "Project",
      icon: "pi pi-fw pi-book",
      items: [
        [
          {
            label: "Project plans",
            items: [
              {
                label: "Go to Plans",
                command: () => {
                  _this.handleClick("plans");
                }
              }
            ]
          },
          {
            label: "Product roadmaps",
            items: [
              {
                label: "Go to Roadmaps",
                command: () => {
                  _this.handleClick("roadmaps");
                }
              }
            ]
          }
        ],
        [
          {
            label: "Test and release schedules",
            items: [
              {
                label: "Go to Test & Release",
                command: () => {
                  _this.handleClick("test&Release");
                }
              }
            ]
          },
          {
            label: "Meeting minutes",
            items: [
              {
                label: "Go to Minutes",
                command: () => {
                  _this.handleClick("meetingMinutes");
                }
              }
            ]
          }
        ],
        [
          {
            label: "Retrospectives",
            items: [
              {
                label: "Go to Retrospectives",
                command: () => {
                  _this.handleClick("retrospectives");
                }
              }
            ]
          },
          {
            label: "Reports",
            items: [
              {
                label: "Go to Reports",
                command: () => {
                  _this.handleClick("reports");
                }
              }
            ]
          }
        ]
      ]
    }
  ];
}
export function getDocumentationStructure() {
  return {
    key: "0",
    data: { label: "Software" },
    children: [
      {
        key: "0_0",
        data: { label: "Product" },
        children: [
          {
            key: "0_0_0",
            data: { label: "System" },
            selectable: false
          },
          {
            key: "0_0_1",
            data: { label: "User" },
            children: [
              {
                key: "0_0_1_0",
                data: { label: "End User" },
                selectable: false
              },
              {
                key: "0_0_1_1",
                data: { label: "Sysadmin" },
                selectable: false
              }
            ]
          }
        ]
      },
      {
        key: "0_1",
        data: { label: "Project" },
        selectable: false
      }
    ]
  };
}

export function getUserDocumentationItems(_this) {
  return [
    {
      label: "Overview",
      icon: "pi pi-fw pi-compass",
      items: [
        [
          {
            label: "Structure",
            items: [
              {
                label: "Go to Structure",
                command: () => {
                  _this.handleClick("docs");
                }
              }
            ]
          }
        ]
      ]
    },
    {
      label: "User Documentation",
      icon: "pi pi-fw pi-users",
      items: [
        [
          {
            label: "End User Documentation",
            items: [
              {
                label: "Go to End User Docs",
                command: () => {
                  _this.handleClick("endUserDocs");
                }
              }
            ]
          },
          {
            label: "Sysadmin Documentation",
            items: [
              {
                label: "Go to Sysadmin",
                command: () => {
                  _this.handleClick("sysadmin");
                }
              }
            ]
          }
        ]
      ]
    }
  ];
}
export function getUserDocumentationStructure() {
  return {
    key: "0",
    data: { label: "User Documentation" },
    children: [
      {
        key: "0_0_1_0_0",
        data: { label: "Tutorials" },
        selectable: false
      },
      {
        key: "0_0_1_0_1",
        data: { label: "User guides" },
        selectable: false
      },
      {
        key: "0_0_1_0_2",
        data: { label: "Troubleshooting Manuals" },
        selectable: false
      },
      {
        key: "0_0_1_0_3",
        data: { label: "FAQs" },
        selectable: false
      }
    ]
  };
}
